import React, { useState, useEffect } from "react";
import shopApi from "../../api/shop";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

function AddProductForm() {
    const [searchTerm, setSearchTerm] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);

    console.log(searchResults, "searchResults");

    const [formData, setFormData] = useState({
        name: { en: "", fr: "" },
        description: { en: "", fr: "" },
        richDescription: { en: "", fr: "" },
        images: [],
        brand: "",
        price: "",
        category: "", // Assuming the category will be an ObjectId
        parent: "",
        countInStock: "",
        rating: 0,
        isFeatured: false,
        isBestSeller: false,
        specifications: [
            { name: { en: "", fr: "" }, features: [{ name: { en: "", fr: "" }, value: { en: "", fr: "" } }] },
        ],
        dateCreated: "", // Optional
        sku: "",
        tags: [],
    });

    const locale = useSelector((state) => state.locale);

    useEffect(() => {
        if (searchTerm.length > 2) {
            shopApi
                .getSuggestions(searchTerm)
                .then((response) => setSearchResults(response))
                .catch((error) => console.error("Error fetching products:", error));
        } else {
            setSearchResults([]);
        }
    }, [searchTerm, locale]);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleSelectProduct = (product) => {
        setSelectedProduct(product);
        setFormData({
            name: product.name || { en: "", fr: "" },
            description: product.description || { en: "", fr: "" },
            richDescription: product.richDescription || { en: "", fr: "" },
            images: product.images || [],
            brand: product.brand || "",
            price: product.price || "",
            category: product.category || "",
            parent: product.parent || "",
            countInStock: product.countInStock || "",
            rating: product.rating || 0,
            isFeatured: product.isFeatured || false,
            isBestSeller: product.isBestSeller || false,
            specifications:
                product.specifications.length > 0
                    ? product.specifications
                    : [
                          {
                              name: { en: "", fr: "" },
                              features: [{ name: { en: "", fr: "" }, value: { en: "", fr: "" } }],
                          },
                      ],
            dateCreated: product.dateCreated || "",
            sku: product.sku || "",
            tags: product.tags || [],
        });
        setSearchTerm("");
        setSearchResults([]);
    };

    // Handle form field changes
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name.includes(".")) {
            const [field, subField] = name.split(".");
            setFormData((prevState) => ({
                ...prevState,
                [field]: {
                    ...prevState[field],
                    [subField]: value,
                },
            }));
        } else {
            setFormData((prevState) => ({
                ...prevState,
                [name]: type === "checkbox" ? checked : value,
            }));
        }
    };

    // Handle file upload
    const handleFileChange = (event) => {
        const files = event.target.files;
        setFormData((prevState) => ({
            ...prevState,
            images: Array.from(files),
        }));
    };

    // Handle adding/removing specifications
    const handleSpecificationChange = (index, lang, e) => {
        const updatedSpecifications = [...formData.specifications];
        updatedSpecifications[index].name[lang] = e.target.value;
        setFormData({ ...formData, specifications: updatedSpecifications });
    };

    const handleFeatureChange = (specIndex, featureIndex, lang, e) => {
        const updatedSpecifications = [...formData.specifications];
        updatedSpecifications[specIndex].features[featureIndex].name[lang] = e.target.name.includes("Name")
            ? e.target.value
            : updatedSpecifications[specIndex].features[featureIndex].name[lang];

        updatedSpecifications[specIndex].features[featureIndex].value[lang] = e.target.name.includes("Value")
            ? e.target.value
            : updatedSpecifications[specIndex].features[featureIndex].value[lang];

        setFormData({ ...formData, specifications: updatedSpecifications });
    };

    const handleAddSpecification = () => {
        setFormData({
            ...formData,
            specifications: [
                ...formData.specifications,
                { name: { en: "", fr: "" }, features: [{ name: { en: "", fr: "" }, value: { en: "", fr: "" } }] },
            ],
        });
    };

    const handleAddFeature = (specIndex) => {
        const updatedSpecifications = [...formData.specifications];
        updatedSpecifications[specIndex].features.push({ name: { en: "", fr: "" }, value: { en: "", fr: "" } });
        setFormData({ ...formData, specifications: updatedSpecifications });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        const productData = new FormData();

        Object.keys(formData).forEach((key) => {
            if (key === "specifications" || key === "tags") {
                productData.append(key, JSON.stringify(formData[key]));
            } else if (key === "images") {
                formData.images.forEach((file) => productData.append("images", file));
            } else if (key === "name" || key === "description" || key === "richDescription") {
                // Ajouter les champs "name", "description" et "richDescription" en JSON pour conserver les traductions
                productData.append(key, JSON.stringify(formData[key]));
            } else {
                productData.append(key, formData[key]);
            }
        });

        try {
            if (selectedProduct) {
                shopApi
                    .updateProduct(formData, selectedProduct._id)
                    .then((response) => {
                        console.log("Product updated:", response.data);
                        setSelectedProduct(null);
                        setFormData({
                            name: { en: "", fr: "" },
                            description: { en: "", fr: "" },
                            richDescription: { en: "", fr: "" },
                            images: [],
                            brand: "",
                            price: "",
                            category: "",
                            parent: "",
                            countInStock: "",
                            rating: 0,
                            isFeatured: false,
                            isBestSeller: false,
                            specifications: [
                                {
                                    name: { en: "", fr: "" },
                                    features: [{ name: { en: "", fr: "" }, value: { en: "", fr: "" } }],
                                },
                            ],
                            dateCreated: "",
                            sku: "",
                            tags: [],
                        });
                    })
                    .catch((error) => console.error("Error updating product:", error));
            } else {
                const response = await shopApi.addProduct(productData);
                if (response) {
                    toast.success("Product added successfully!", {
                        theme: "colored",
                        autoClose: 20000,
                    });
                    setFormData({
                        name: { en: "", fr: "" },
                        description: { en: "", fr: "" },
                        richDescription: { en: "", fr: "" },
                        images: [],
                        brand: "",
                        price: "",
                        category: "",
                        parent: "",
                        countInStock: "",
                        rating: 0,
                        isFeatured: false,
                        isBestSeller: false,
                        specifications: [
                            {
                                name: { en: "", fr: "" },
                                features: [{ name: { en: "", fr: "" }, value: { en: "", fr: "" } }],
                            },
                        ],
                        dateCreated: "",
                        sku: "",
                        tags: [],
                    });
                }
            }
        } catch (error) {
            console.error("Error creating product:", error);
            toast.error("Failed to add product.", {
                theme: "colored",
            });
        }
    };
    return (
        <div className="container mt-5">
            <div className="position-relative">
                <input
                    type="text"
                    className="form-control mt-2"
                    placeholder="Rechercher un produit..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                />
                {searchResults?.length > 0 && (
                    <ul
                        className="list-group position-absolute w-100 mt-1 shadow bg-white rounded border"
                        style={{ zIndex: 1050 }}
                    >
                        {searchResults.map((product) => (
                            <li
                                key={product._id}
                                className="list-group-item list-group-item-action"
                                onClick={() => handleSelectProduct(product)}
                            >
                                {product.name[locale] || product.name.en}
                            </li>
                        ))}
                    </ul>
                )}
              
            </div>
            <form
                onSubmit={handleSubmit}
                encType="multipart/form-data"
                className="p-4 border rounded mt-4 shadow-sm bg-light"
            >
                <div className="form-row">
                    {/* Name */}
                    <div className="form-group col-md-6">
                        <label>Name (English)</label>
                        <input
                            type="text"
                            className="form-control"
                            name="name.en"
                            value={formData.name.en}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Name (French)</label>
                        <input
                            type="text"
                            className="form-control"
                            name="name.fr"
                            value={formData.name.fr}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>

                <div className="form-row">
                    {/* Description */}
                    <div className="form-group col-md-6">
                        <label>Description (English)</label>
                        <textarea
                            className="form-control"
                            name="description.en"
                            value={formData.description.en}
                            onChange={handleChange}
                            required
                        ></textarea>
                    </div>
                    <div className="form-group col-md-6">
                        <label>Description (French)</label>
                        <textarea
                            className="form-control"
                            name="description.fr"
                            value={formData.description.fr}
                            onChange={handleChange}
                            required
                        ></textarea>
                    </div>
                </div>

                {/* Rich Description */}
                <div className="form-row">
                    <div className="form-group col-md-12">
                        <label>Rich Description (English)</label>
                        <textarea
                            className="form-control"
                            name="richDescription.en"
                            value={formData.richDescription.en}
                            onChange={handleChange}
                        ></textarea>
                    </div>
                    <div className="form-group col-md-12">
                        <label>Rich Description (French)</label>
                        <textarea
                            className="form-control"
                            name="richDescription.fr"
                            value={formData.richDescription.fr}
                            onChange={handleChange}
                        ></textarea>
                    </div>
                </div>

                {/* Images */}
                <div className="form-group">
                    <label>Images</label>
                    <input type="file" className="form-control-file" multiple onChange={handleFileChange} />
                </div>

                <div className="form-row">
                    {/* Brand, Price, Category */}
                    <div className="form-group col-md-4">
                        <label>Brand</label>
                        <input
                            type="text"
                            className="form-control"
                            name="brand"
                            value={formData.brand}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <label>Price</label>
                        <input
                            type="number"
                            className="form-control"
                            name="price"
                            value={formData.price}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <label>Category</label>
                        <input
                            type="text"
                            className="form-control"
                            name="category"
                            value={formData.category}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="form-row">
                    {/* SKU, Date Created, Tags */}
                    <div className="form-group col-md-4">
                        <label>SKU</label>
                        <input
                            type="text"
                            className="form-control"
                            name="sku"
                            value={formData.sku}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <label>Date Created</label>
                        <input
                            type="date"
                            className="form-control"
                            name="dateCreated"
                            value={formData.dateCreated}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <label>Tags</label>
                        <input
                            type="text"
                            className="form-control"
                            name="tags"
                            value={formData.tags.join(", ")}
                            onChange={(e) => setFormData({ ...formData, tags: e.target.value.split(", ") })}
                        />
                    </div>
                </div>
                <div className="form-row">
                    {/* Parent, Count in Stock, Rating, Is Featured, Is Best Seller */}
                    <div className="form-group col-md-4">
                        <label>Parent</label>
                        <input
                            type="text"
                            className="form-control"
                            name="parent"
                            value={formData.parent}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <label>Count In Stock</label>
                        <input
                            type="number"
                            className="form-control"
                            name="countInStock"
                            value={formData.countInStock}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <label>Rating</label>
                        <input
                            type="number"
                            className="form-control"
                            name="rating"
                            value={formData.rating}
                            onChange={handleChange}
                            min="0"
                            max="5"
                        />
                    </div>
                </div>
                <div className="form-row col-md-12 ml-2">
                    {/* Is Featured */}
                    <div className="form-group col-md-4 d-flex justify-content-between align-items-center">
                        <label htmlFor="isFeatured" className="form-check-label mb-0">
                            Is Featured
                        </label>
                        <input
                            type="checkbox"
                            className="form-check-input"
                            name="isFeatured"
                            checked={formData.isFeatured}
                            onChange={handleChange}
                            id="isFeatured"
                        />
                    </div>

                    {/* Is Best Seller */}
                    <div className="form-group col-md-4 d-flex justify-content-between align-items-center">
                        <label htmlFor="isBestSeller" className="form-check-label mb-0">
                            Is Best Seller
                        </label>
                        <input
                            type="checkbox"
                            className="form-check-input"
                            name="isBestSeller"
                            checked={formData.isBestSeller}
                            onChange={handleChange}
                            id="isBestSeller"
                        />
                    </div>
                </div>

                {/* Specifications */}
                <div className="form-group">
                    <label>Specifications</label>
                    {formData.specifications.map((spec, index) => (
                        <div key={index}>
                            <div className="d-flex">
                                <input
                                    type="text"
                                    name="nameEn"
                                    value={spec.name.en}
                                    onChange={(e) => handleSpecificationChange(index, "en", e)}
                                    placeholder="Specification Name (EN)"
                                    className="form-control mr-2"
                                />
                                <input
                                    type="text"
                                    name="nameFr"
                                    value={spec.name.fr}
                                    onChange={(e) => handleSpecificationChange(index, "fr", e)}
                                    placeholder="Specification Name (FR)"
                                    className="form-control"
                                />
                            </div>
                            {spec.features.map((feature, fIndex) => (
                                <div key={fIndex} className="d-flex mt-2">
                                    <div className="d-flex flex-grow-1">
                                        <input
                                            type="text"
                                            name="featureNameEn"
                                            value={feature.name.en}
                                            onChange={(e) => handleFeatureChange(index, fIndex, "en", e)}
                                            placeholder="Feature Name (EN)"
                                            className="form-control mr-2"
                                        />
                                        <input
                                            type="text"
                                            name="featureNameFr"
                                            value={feature.name.fr}
                                            onChange={(e) => handleFeatureChange(index, fIndex, "fr", e)}
                                            placeholder="Feature Name (FR)"
                                            className="form-control mr-2"
                                        />
                                    </div>
                                    <div className="d-flex flex-grow-1">
                                        <input
                                            type="text"
                                            name="featureValueEn"
                                            value={feature.value.en}
                                            onChange={(e) => handleFeatureChange(index, fIndex, "en", e)}
                                            placeholder="Feature Value (EN)"
                                            className="form-control mr-2"
                                        />
                                        <input
                                            type="text"
                                            name="featureValueFr"
                                            value={feature.value.fr}
                                            onChange={(e) => handleFeatureChange(index, fIndex, "fr", e)}
                                            placeholder="Feature Value (FR)"
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                            ))}
                            <button
                                type="button"
                                className="btn btn-secondary mt-2 mb-2"
                                onClick={() => handleAddFeature(index)}
                            >
                                Add Feature
                            </button>
                        </div>
                    ))}
                    <button type="button" className="btn btn-secondary mt-3" onClick={handleAddSpecification}>
                        Add Specification
                    </button>
                </div>

                {/* Submit Button */}
                <button type="submit" className="btn btn-primary btn-block mt-4">
                    {selectedProduct ? "Modifier Product" : "Create Product"}
                </button>
            </form>
        </div>
    );
}

export default AddProductForm;
